function formatPhoneNumber(numberIn) {
    let numberOut = numberIn.replace(/[\s()-]/g, '');
    if (numberIn.length === 12 && numberIn.slice(0, 2) === "+1") {
        numberOut = numberIn.slice(2);
    } else if (numberIn.charAt(0) === "+") numberOut = numberIn.slice(1);
    if (numberOut.length > 6) numberOut = `(${numberOut.slice(0, 3)}) ${numberOut.slice(3, 6)}-${numberOut.slice(6)}`;
    return numberOut;
}

export default formatPhoneNumber;